import { SelectItem } from 'primeng/api';
import { Stage } from '../../models/rule.model';

export const stageOptions: SelectItem[] = [
  { label: 'Tous', value: 'all' },
  { label: 'En développement', value: Stage.Dev },
  { label: 'En validation', value: Stage.Qa },
  { label: 'Mature - investigation', value: Stage.ProdManual },
  { label: 'Mature - Avis automatisé', value: Stage.ProdAutomated },
];
